import { useQuery } from '@tanstack/react-query';
import Card from '../../components/common/Card';
import AnnouncementCard from '../../components/announcements/AnnouncementCard';
import { getAnnouncements } from '../../services/announcementService';
import { MdCampaign } from 'react-icons/md';

function TrainerAnnouncements() {
  document.title = 'Announcements — TrainAxis';
  const { data, isPending } = useQuery({
    queryKey: ['announcements-trainer'],
    queryFn:  () => getAnnouncements({ audience: 'trainers' }).then(r => r.data),
    refetchInterval: 60000, // check every minute
  });

  const announcements = data?.announcements || [];

  return (
    <div className="mx-auto w-full max-w-4xl">
      <p className="text-muted text-sm mb-6">{announcements.length} notice{announcements.length !== 1 ? 's' : ''}</p>

      {isPending ? (
        <div className="flex flex-col gap-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-32 bg-gray-100 animate-pulse rounded-lg" />
          ))}
        </div>
      ) : !announcements.length ? (
        <Card>
          <div className="flex flex-col items-center py-14 text-center">
            <MdCampaign className="text-5xl text-subtle mb-3" />
            <p className="text-muted text-sm">No announcements</p>
          </div>
        </Card>
      ) : (
        <div className="flex flex-col gap-3">
          {announcements.map(a => (
            <AnnouncementCard key={a._id} announcement={a} />
          ))}
        </div>
      )}
    </div>
  );
}

export default TrainerAnnouncements;
